import React, { FC, useRef } from 'react';
import { FormInput } from '../merchants/FormInput';
import { ButtonComponent } from '../ButtonComponent';
import { useTranslation } from 'react-i18next';
import { ACTIVITY_LOG_FIELDS } from '../../constants/activity-log/activity-log-fields';
import { useOrdersContext } from '../../store/order/order-context';

export const ActivityLogFilters: FC<{ formik: any }> = ({ formik }) => {
	const { t } = useTranslation();
	const picker = useRef(null);

	const { orderContextState: { isOrderActivityLogDataLoading, orderActivityLogLists }} = useOrdersContext();

	const allInformationValue = orderActivityLogLists?.informationLevels?.map(item => item.value);

	const allCategoryValue = orderActivityLogLists?.activityCategories?.map(item => item.value);

	const infoList = orderActivityLogLists?.informationLevels;
	const categoryList = orderActivityLogLists?.activityCategories;

	const INPUTS = ACTIVITY_LOG_FIELDS({ t, infoList, categoryList, picker, allCategoryValue, allInformationValue });


	return (
		<div className="card mb-10">
			<div className="card-body">
				<form className="d-md-flex align-items-center justify-content-between" onSubmit={formik.handleSubmit}>
					<div className="row col-md-11">
						{
							INPUTS.map(item => (
								<FormInput
									{...item}
									key={item.key}
									formik={formik}
								/>
							))
						}
					</div>
					<ButtonComponent
						buttonName={t('ORDERS.FILTER_BTN_NAME')}
						additionalClass="btn-sm mb-0 mb-md-4 filter-btn-width d-block ms-auto"
						loading={isOrderActivityLogDataLoading}
						isDisabled={isOrderActivityLogDataLoading}
						type="submit"
					/>

				</form>
			</div>
		</div>
	);
};